enum ScheduleFrequency {
    Once = "ONCE",
    Daily = "DAILY",
    Weekly = "WEEKLY",
    TwoWeekly = "TWO_WEEKLY",
    Monthly = "MONTHLY",
    Quarterly = "QUARTERLY",
    Annually = "ANNUALLY"
}
export default ScheduleFrequency